import React, { Component } from 'react'
import Helmet from 'react-helmet'
import WithData from '../components/common/with-data.js'
import { renderComponent } from '../components/common/render-components.js'
import {
  DivWithBackgroundColor,
  PrimaryDiv,
  SecondaryLi,
} from '../components/shared-page-components/styled-components.js'
import '../assets/stylesheets/about.scss'

class Studio extends Component {
  render() {
    const {
      metaPageTitle,
      metaPageDescription,
      metaImage,
      metaImageTwitter,
      rotatedTitle,
      aboutPageIntroductionText,
      servicesLeftColumn,
      servicesRightColumn,
      aboutPageContentComponents,
      aboutPageBackgroundColor,
      aboutPagePrimaryColor,
      aboutPageSecondaryColor,
    } = this.props

    function addColorsToComponents(component) {
      component.primaryColor = aboutPagePrimaryColor
      component.secondaryColor = aboutPageSecondaryColor
      component.backgroundColor = aboutPageBackgroundColor
    }

    aboutPageContentComponents.map(component => {
      return addColorsToComponents(component)
    })

    const PageMetaContent = () => (
      <Helmet>
        <title>{metaPageTitle}</title>
        <meta property="og:title" content={metaPageTitle} />
        <meta property="twitter:title" content={metaPageTitle} />
        <meta name="description" content={metaPageDescription} />
        <meta property="og:description" content={metaPageDescription} />
        <meta property="twitter:description" content={metaPageDescription} />
        <meta
          property="og:image"
          content={`${metaImage.file.url}?w=1200&h=630&fit=fill&fm=jpg&q=90`}
        />
        <meta
          property="twitter:image"
          content={`${
            metaImageTwitter.file.url
          }?w=800&h=418&fit=fill&fm=jpg&q=90`}
        />
        <meta
          name="og:url"
          content={`${process.env.GATSBY_SITE_BASE_URL}/studio`}
        />
      </Helmet>
    )

    return (
      <DivWithBackgroundColor
        id="aboutpage"
        backgroundColor={aboutPageBackgroundColor}
      >
        <PrimaryDiv primaryTextColor={aboutPagePrimaryColor}>
          <PageMetaContent />

          <header className="grid-row full-page" />

          {aboutPageIntroductionText && (
            <section className="grid-row">
              <div className="aboutpage-introduction">
                <p>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: aboutPageIntroductionText,
                    }}
                  />
                </p>
              </div>
            </section>
          )}

          <section className="aboutpage-services grid-row">
            <div className="section-column tag-lists">
              <TagList
                name="services left"
                items={servicesLeftColumn}
                color={aboutPageSecondaryColor}
              />
              <TagList
                name="services right"
                items={servicesRightColumn}
                color={aboutPageSecondaryColor}
              />
            </div>
          </section>

          {aboutPageContentComponents.map((component, i) => {
            return renderComponent(component, i)
          })}
        </PrimaryDiv>
      </DivWithBackgroundColor>
    )
  }
}

class TagList extends Component {
  render() {
    const { name, items, color } = this.props
    const itemsToArray = items.toString().split(',')

    return (
      <div className="tag-list">
        <div className={name}>
          <ol>
            {itemsToArray.map((item, i) => {
              return (
                <SecondaryLi secondaryTextColor={color} key={`services_${i}`}>
                  {item}
                </SecondaryLi>
              )
            })}
          </ol>
        </div>
      </div>
    )
  }
}

export default WithData(mapDataToProps, Studio)

function mapDataToProps(data) {
  const page = data.contentfulAboutPage

  return {
    title: page.title || '',
    metaPageTitle: page.metaPageTitle || '',
    metaPageDescription: page.metaPageDescription.metaPageDescription || '',
    metaImage: page.metaImage ? page.metaImage : { file: { url: '' } },
    metaImageTwitter: page.metaImageTwitter
      ? page.metaImageTwitter
      : { file: { url: '' } },
    rotatedTitle: page.rotatedTitle || '',
    servicesLeftColumn: page.servicesLeftColumn ? page.servicesLeftColumn : '',
    servicesRightColumn: page.servicesRightColumn
      ? page.servicesRightColumn
      : '',
    aboutPageIntroductionText: page.aboutPageIntroductionText
      ? page.aboutPageIntroductionText.aboutPageIntroductionText
      : '',
    servicesLeftColumn: page.servicesLeftColumn ? page.servicesLeftColumn : '',
    servicesRightColumn: page.servicesRightColumn
      ? page.servicesRightColumn
      : '',
    aboutPageContentComponents: page.aboutPageContentComponents
      ? page.aboutPageContentComponents
      : [{}],
    aboutPageBackgroundColor: page.aboutPageBackgroundColor
      ? page.aboutPageBackgroundColor
      : '',
    aboutPagePrimaryColor: page.aboutPagePrimaryColor
      ? page.aboutPagePrimaryColor
      : '',
    aboutPageSecondaryColor: page.aboutPageSecondaryColor
      ? page.aboutPageSecondaryColor
      : '',
  }
}

export const query = graphql`
  query aboutQuery {
    contentfulAboutPage(pageTitle: { eq: "About Page - Master" }) {
      metaPageTitle
      metaPageDescription {
        metaPageDescription
      }
      metaImage {
        file {
          url
        }
      }
      metaImageTwitter {
        file {
          url
        }
      }
      rotatedTitle
      aboutPageIntroductionText {
        aboutPageIntroductionText
      }
      servicesLeftColumn
      servicesRightColumn
      aboutPageContentComponents {
        ...allAboutPageCareerLinks
        ...allAboutPageImageBlocks
        ...allAboutPageHalfImageBlocks
        ...allAboutPageCarousels
        ...allAboutPageQuotes
        ...allAboutPageTextBlocks
        ...allAboutPageVideosClickToPlay
        ...allAboutPageVideosMutedAutoplay
        ...allAboutPageFeatureTwoImageBlock
        ...allAboutPageFeatureImageBlocks
        ...allAboutPageFeatureHalfImageBlocks
        ...allAboutPageClientGrids
        ...allAboutPageItemListBlocks
        ...allAboutPageAccordions
      }
      aboutPageBackgroundColor
      aboutPagePrimaryColor
      aboutPageSecondaryColor
    }
  }

  fragment allAboutPageCareerLinks on ContentfulComponentCareersLinks {
    __typename
    title
    blockTitle
    blockCopy {
      blockCopy
    }
    jobs {
      jobDisplayTitle
      jobDescriptionPdf {
        file {
          url
        }
      }
    }
    textColor
    contentColumnWidth
    shiftContent
    marginBelow
  }

  fragment allAboutPageClientGrids on ContentfulGridComponentClientLogoGrid {
    __typename
    title
    clientReferences {
      title
      linkUrl
      logo {
        file {
          url
        }
      }
    }
    marginBelow
  }

  fragment allAboutPageAccordions on ContentfulComponentAccordion {
    __typename
    title
    label
    closeLabel
    linkedComponents {
      ...allAboutPageCarousels
      ...allAboutPageHalfImageBlocks
      ...allAboutPageImageBlocks
      ...allAboutPageQuotes
      ...allAboutPageTextBlocks
      ...allAboutPageVideosClickToPlay
      ...allAboutPageVideosMutedAutoplay
    }
    marginBelow
  }

  fragment allAboutPageImageBlocks on ContentfulComponentImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageContentColumnWidth
    imageShiftContent
    captionTitle
    captionCopy {
      captionCopy
    }
    captionContentColumnWidth
    captionShiftContent
    marginBelow
  }

  fragment allAboutPageHalfImageBlocks on ContentfulComponentHalfImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageAlign
    doesImageTakesFullWidthOnMobile
    captionTitle
    captionCopy {
      captionCopy
    }
    captionAlign
    marginBelow
  }

  fragment allAboutPageCarousels on ContentfulComponentCarousel {
    __typename
    slides {
      title
      image {
        file {
          url
        }
      }
      captionTitle
      captionCopy {
        captionCopy
      }
    }
    marginBelow
  }

  fragment allAboutPageQuotes on ContentfulComponentQuote {
    __typename
    title
    circleCroppedImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
    quoteAuthorOrSocialHandle
    contentColumnWidth
    shiftContent
    marginBelow
    linkToAuthorOrSocialMedia
  }

  fragment allAboutPageTextBlocks on ContentfulComponentTextBlock {
    __typename
    title
    blockTitle
    blockCopy {
      blockCopy
    }
    textColor
    contentColumnWidth
    shiftContent
    marginBelow
  }

  fragment allAboutPageVideosClickToPlay on ContentfulComponentVideoClickToPlay {
    __typename
    title
    vimeoUrl
    posterOverlayColor
    columnWidth
    alignment
    captionTitle
    captionAlignment
    marginBelow
    vimeoPosterImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
  }

  fragment allAboutPageVideosMutedAutoplay on ContentfulComponentVideoMutedAutoplay {
    __typename
    title
    vimeoUrl
    columnWidth
    alignment
    captionTitle
    captionAlignment
    marginBelow
    vimeoPosterImage {
      file {
        url
      }
    }
    captionCopy {
      captionCopy
    }
  }

  fragment allAboutPageFeatureTwoImageBlock on ContentfulFeatureComponentTwoImageBlock {
    __typename
    title
    leftImage {
      file {
        url
      }
    }
    leftImageExternalLink
    leftImageCaseStudyReference {
      slug
    }
    leftCaptionTitle
    leftImageOverlayColor
    leftCaptionCopy {
      leftCaptionCopy
    }
    rightImage {
      file {
        url
      }
    }
    rightImageExternalLink
    rightImageCaseStudyReference {
      slug
    }
    rightImageOverlayColor
    rightCaptionTitle
    rightCaptionCopy {
      rightCaptionCopy
    }
    marginBelow
  }

  fragment allAboutPageFeatureImageBlocks on ContentfulFeatureComponentImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageContentColumnWidth
    imageShiftContent
    captionTitle
    captionCopy {
      captionCopy
    }
    captionContentColumnWidth
    captionShiftContent
    marginBelow
    imageOverlayColor
    imageCaseStudyReference {
      slug
    }
    imageExternalLink
  }

  fragment allAboutPageFeatureHalfImageBlocks on ContentfulFeatureComponentHalfImageBlock {
    __typename
    title
    image {
      file {
        url
      }
    }
    imageAlign
    doesImageTakesFullWidthOnMobile
    captionTitle
    captionCopy {
      captionCopy
    }
    captionAlign
    marginBelow
    imageOverlayColor
    imageCaseStudyReference {
      slug
    }
    imageExternalLink
  }

  fragment allAboutPageItemListBlocks on ContentfulComponentItemListBlock {
    __typename
    title
    blockTitle
    blockCopyListItems {
      blockCopyListItems
    }
    marginBelow
  }
`



// WEBPACK FOOTER //
// ./src/pages/studio.js